import { memo } from 'react'
import Layout from './layout'
import { LootboxCompetition } from '@/components/templates/Lootbox/templates/LootboxCompetition'

const LootboxCompetitionPage = () => {
  return (
    <Layout>
      <LootboxCompetition />
    </Layout>
  )
}

export default memo(LootboxCompetitionPage)
